import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgGift({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 2a4 4 0 014 4v1h2V6a4 4 0 014-4h1a2.333 2.333 0 011.4 4.2l-1.068.8H20a2 2 0 012 2v2a2 2 0 01-.999 1.732L21 19a3 3 0 01-3 3H6a3 3 0 01-3-3v-6.268A2 2 0 012 11V9a2 2 0 012-2h1.667L4.6 6.2A2.333 2.333 0 016 2h1zm4 11H5v6a1 1 0 001 1h5v-7zm8 0h-6v7h5a1 1 0 001-1v-6zm-8-4H4v2h7V9zm9 0h-7v2h7V9zM7 4H6a.333.333 0 00-.2.6L9 7V6a2 2 0 00-2-2zm11 0h-1a2 2 0 00-2 2v1l3.2-2.4A.333.333 0 0018 4z"
        fill={color}
      />
    </svg>
  )
}

export default SvgGift
